import axios from 'axios';
import { useState } from 'react';

import Content from './components/Content.jsx';
import Contribution from './components/Contribution.jsx';
import Day from './components/Day.jsx';
import Email from './components/Email.jsx';
import Form from './components/Form.jsx';
import Grouping from './components/Grouping.jsx';
import Matching from './components/Matching.jsx';
import Message from './components/Message.jsx';
import Profile from './components/Profile.jsx';
import QuestionTest from './components/QuestionTest.jsx';
import Result from './components/Result.jsx';
import ResultContribution from './components/ResultContribution.jsx';
import Website from './components/Website.jsx';
import Yesno from './components/Yesno.jsx';
import Modal from './ui/Modal.jsx';

import HackPassword from './components/HackPassword.jsx';
import MessageBoss from './components/MessageBoss.jsx';
import MobileScrolling from './components/MobileScrolling.jsx';
import PcLogin from './components/PcLogin.jsx';
import PcProofs from './components/PcProofs.jsx';
import TextBox from './components/TextBox.jsx';
import Uncovering from './components/Uncovering.jsx';
import WhatDo from './components/WhatDo.jsx';
import WriteArticle from './components/WriteArticle.jsx';

import { Button } from '@headlessui/react';
import FallingTitles from './components/FallingTitles.jsx';
import QuestionsResult from './components/QuestionsResult.jsx';
import StoryEnd from './components/StoryEnd.jsx';

const App = () => {
    const data = JSON.parse(document.getElementById('ReactGame').dataset.game) ?? null;

    const { user, team, pages } = data ?? null;
    const [step, setStep] = useState(parseInt(data.step));
    const [response, setResponse] = useState();
    const [form, setForm] = useState({});
    const [feedback, setFeedback] = useState();
    const [modal, setModal] = useState({ isOpen: false, ...null });
    const [money, setMoney] = useState(team?.money ?? null);

    const [pageData, setPageData] = useState(null);
    const handleAction = (action, data = null) => {
        // console.log(action);
        if (action == undefined) {
            console.warn('action is undefined');
        }

        if (typeof action === 'object') {
            action.map((item) => {
                makeAction(item, data);
            });
        } else {
            makeAction(action, data);
        }
    };

    const makeAction = (action, data) => {
        let actionName = action;
        let actionValue = null;
        if (action.indexOf(':')) {
            [actionName, actionValue] = action.split(':');
        }

        if ('step' === actionName) {
            if ('continue' === actionValue) {
                moveToStep(Number(step) + 1);
            } else {
                moveToStep(Number(actionValue));
            }
        } else if ('send' === actionName) {
            send(actionValue, form);
        } else if ('send.dirty' === actionName) {
            // console.log(data)
            send(actionValue, data);
        } else if ('modal' === actionName) {
            if ('close' === actionValue) {
                setModal({ ...modal, isOpen: false });
            } else if ('set' === actionValue) {
                setModal({ ...data, isOpen: true });
            }
        } else if ('set' === actionName) {
            if ('form' === actionValue) {
                setForm(data);
            }
            if ('feedback' === actionValue) {
                setFeedback(data);
            }
            if ('money' === actionValue) {
                setMoney(data);
            }
        }

        // if (action === 'continue' && data) {
        //     send(data);
        // } else if (action === 'modal.close') {
        //     handleModalClose();
        // } else if (action === 'form.send') {
        //     send(form);
        // } else if (action === 'step') {
        //     if('continue' === data) {
        //         moveToStep(Number(step) + 1);
        //     } else {
        //         moveToStep(data);
        //     }
        // } else if (step < pages.length - 1) {
        //     moveToStep(Number(step) + 1);
        // }
    };

    const handleFormChange = (data) => {
        setForm((prevForm) => {
            return {
                ...prevForm,
                ...data,
            };
        });
    };

    // const handleModalClose = () => {
    //     if (modal.action?.startsWith('step:')) {
    //         const [, stepValue] = modal.action.split(':');
    //         if (stepValue && !isNaN(Number(stepValue))) {
    //             moveToStep(stepValue);
    //         }
    //     }
    //     setModal({ ...modal, isOpen: false });
    // };

    const handleSend = (url) => {
        send(url, form);
    };

    const moveToStep = (index) => {
        if (pages[index] !== undefined) {
            setStep(index);

            if (modal.isOpen) {
                setModal({ ...modal, isOpen: false });
            }
        } else {
            console.error('variable `pages` has not index: ' + index);
            console.error(pages);
        }
    };

    const send = (url, data) => {
        // console.log('axios sending...');
        // console.log(url, {
        //     step: step,
        //     data: data,
        // });
        axios
            .post(url, {
                step: step,
                data: data,
            })
            .then((response) => {
                // console.log('response:');
                // console.log(response.data);
                if (response.data.hasOwnProperty('modal')) {
                    setModal({ isOpen: true, ...response.data.modal });
                }
                if (response.data.hasOwnProperty('form')) {
                    setForm(response.data.form.data || {});
                }
                if (response.data.hasOwnProperty('set:money')) {
                    // setMoney(response.data['set:money'] || 0);
                    setMoney((prevState) => Number.parseInt(prevState) + Number.parseInt(response.data['set:money'] || 0));
                }
                if (response.data.hasOwnProperty('feedback')) {
                    setFeedback(response.data.feedback);
                }
                if (response.data.hasOwnProperty('step')) {
                    moveToStep(response.data.step);
                } else if (response.data.hasOwnProperty('redirect')) {
                    window.location.href = response.data.redirect;
                }
                if (response.data.hasOwnProperty('logout')) {
                    setFeedback(response.data.redirect);
                }
            })
            .catch((error) => {
                console.error('Error saving data:', error);
            });
    };

    const Components = {
        content: Content,
        website: Website,
        message: Message,
        grouping: Grouping,
        matching: Matching,
        form: Form,
        // 'form.clickbait': Form,
        // 'form.phishing': Form,
        yesno: Yesno,
        result: Result,
        day: Day,
        profile: Profile,
        contribution: Contribution,
        'result.contribution': ResultContribution,
        email: Email,
        questiontest: QuestionTest,
        mobilescrolling: MobileScrolling,
        messageboss: MessageBoss,
        uncovering: Uncovering,
        whatdo: WhatDo,

        fallingtitles: FallingTitles,
        'questions.result': QuestionsResult,
        textbox: TextBox,
        writearticle: WriteArticle,
        pclogin: PcLogin,
        hackpassword: HackPassword,
        pcproofs: PcProofs,
        storyend: StoryEnd,
    };

    const pageCurrent = pages[step];
    const Component = Components[pageCurrent.type];
    if (!Component) {
        console.warn(`Component "${pageCurrent.type}" not found.`);
        return '';
    }

    return (
        <>
            <Modal {...modal} fn={{ handleAction }} />
            <header>
                <div className="container">
                    <nav className="navbar">
                        <div className="navbar-brand">
                            <img src="/storage/game/mo-logo-mini.svg" />
                            <span>{team?.name ? 'Název týmu: ' + team.name : ''}</span>
                        </div>
                        <div className="flex items-center">
                            {money > 0 && (
                                <span>Nahrané peníze: {new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 0 }).format(money)} Kč</span>
                            )}
                            {user && (
                                <Button className="btn btn-primary ml-10" onClick={() => handleAction('send:/api/game/logout')}>
                                    Odhlásit se
                                </Button>
                            )}
                        </div>
                    </nav>
                </div>
            </header>
            <main>
                <div className="container">
                    <Component
                        uid={pageCurrent.uid}
                        {...pageCurrent.fields}
                        feedback={feedback}
                        formData={form}
                        fn={{ handleAction, handleFormChange, handleSend }}
                    />
                </div>
            </main>
        </>
    );
};
export default App;
